import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import { AuthService } from '../../../core/auth/auth.service';
import { User }    from '../user';
import { API_ERROR } from '../../../utils/api-error.const';
import { environment } from '../../../../environments/environment';
import {LastActivePageService} from "../../services/last-active-page.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css']
})
export class LoginFormComponent implements OnInit {
  @Input() displayLinks: boolean = true;
  @Input() full : any = false;
  @Input() isShoppingFunnel : any = false;
  modePro: boolean;
  credentials = new User();
  submitted = false;
  errorMsg = '';
  @Output() logged = new EventEmitter<any>();
  errors:any = [];
  hidePassword : boolean = true;
  logoName:any;
  loggedIn: boolean = false;

  constructor(private router: Router, private lastActivePageService: LastActivePageService,private authService: AuthService) {
    this.modePro = environment.pro;
    //pro is using old template like shoppingtunnel,it is patching
    this.isShoppingFunnel = environment.pro;
  }

  toglePasswordVisibility() {
    this.hidePassword =!  this.hidePassword;
  }

  ngOnInit() {
    if(this.modePro) {
      this.full = true;
    }
    this.logoName = (this.modePro) ? 'logo-pro.png' : 'logo.png';
   /* if(this.userIsPreaccount) {
      this.authService.logoutWithoutRedirect();
    }*/
  }

  userIsPreaccount() {
    return this.authService.loggedIn() && this.authService.getUser() && this.authService.getUser().isPreAccount
  }
  validation(validity): boolean  {
    this.errors = [];
    if (!validity) {
      this.errors.push('Formulaire incomplet');
      return false;
    }
    return true;
  }
  onSubmit(validity) {
    console.log('ok');
    if(this.validation(validity)) {
      if(this.userIsPreaccount()) {
        this.authService.logoutWithoutRedirect();
      }
      this.logged.emit('logged');
      this.submitted = true;
      this.authService.login(this.credentials.email, this.credentials.password).then(res => {
            let  user = this.authService.getUser();
            this.logged.emit('logged');
            if(user.is_manager) {
              this.authService.setDestination('/manage/managerevents');
            }
            if(this.modePro && this.authService.UserHasNotOrganisation(user)) {
              this.authService.isProSignupProcessgoin = true;
              this.authService.setDestination('/login/signup');
            } else if (this.modePro && ( user.role_id == 1 || user.isOrga || user.events.length > 0)) {
              this.authService.setDestination('/manage/organization');
            }
          /*  if(this.modePro && ( user.role_id == 1 || user.isOrga || user.events.length >0)) {

            }*/
          console.log('logged in');

          const lastActivePage = this.lastActivePageService.getLastActivePage();
          console.log(lastActivePage);
          if(lastActivePage) {
            console.log(lastActivePage+ ' is last activated page');
            this.router.navigateByUrl(lastActivePage);
          } else {
            this.authService.redirect();
          }
          }).catch(error => {
            this.errorMsg = 'Impossible de vous identifier';
            return;
         /* API_ERROR.get(error.code);*/
        });
    }
  }

}
